import { ButtonLink } from "~/shared/components/ds/ButtonLink";
import {
  ErrorDisplayActions,
  ErrorDisplayContent,
  ErrorDisplayHeadline,
  ErrorDisplayLockup,
  ErrorDisplayLogo,
  ErrorDisplayMessage,
  ErrorDisplayRoot,
} from "~/shared/components/errors/ErrorDisplay";
import { PARTNER_PATHS } from "~/team/constants/paths.constants";

export function PartnerNotFound() {
  return (
    <ErrorDisplayRoot>
      <ErrorDisplayLogo />

      <ErrorDisplayContent>
        <ErrorDisplayLockup>
          <ErrorDisplayHeadline>Partner Not Found</ErrorDisplayHeadline>
          <ErrorDisplayMessage>
            We couldn&apos;t find the partner you were looking for. Check the partner list to find the right partner, or
            try reloading the page.
          </ErrorDisplayMessage>
        </ErrorDisplayLockup>
        <ErrorDisplayActions>
          <ButtonLink variant="default" to={PARTNER_PATHS.root}>
            Go to Partners
          </ButtonLink>
        </ErrorDisplayActions>
      </ErrorDisplayContent>
    </ErrorDisplayRoot>
  );
}
